import { ActivityIndicator, Text, Pressable, Platform,StyleSheet } from 'react-native';
import gs from '../../styles/globalStyles';
import ls from './styles';
import classes from '../../styles/globalClasses';
import { ColorTokensMap } from '@voltmoney/schema';
import { trackEvent } from '../../utils/amplitude';
import { checkColor } from '@app/utils';
import { ThemedPressable, ThemedText } from '@app/theme';
interface ButtonProps {
  size?: 'LG' | 'MD' | 'SM';
  disabled?: boolean;
  handlePress: () => void;
  bg: string;
  textColor: string;
  label: string;
  buttonLoader?: boolean;
  showLeftAccessory?: boolean;
  leftAccessory?: () => JSX.Element;
  showRightAccessory?: boolean;
  rightAccessory?: () => JSX.Element;
  showShadow?: boolean;
  eventName?: string;
  additionalProperties?: Record<string, any>
  overRideStyle?: any;
  type?: 'SOLID' | 'TEXT' | 'OUTLINED';
}


const buttonSize ={
  LG :48,
  MD :40,
  SM :32,
}

const textSize ={
  LG :16 ,
  MD : 14 ,
  SM :12 ,
}

const Button = ({
  size = 'LG',
  label,
  type = 'SOLID',
  disabled = false,
  handlePress = () => {},
  showLeftAccessory = false,
  showRightAccessory = false,
  leftAccessory = () => <></>,
  rightAccessory = () => <></>,
  buttonLoader = false,
  showShadow = false,
  eventName,
  additionalProperties,
  overRideStyle={}
}: ButtonProps) => {
  const ButtonBg = (disabled: boolean, type: string) => {
    if (disabled && type === 'SOLID') {
      return 'bg-action-disabled';
    } else if (!disabled && type === 'SOLID') {
      return 'bg-action-primary';
    } else {
      return 'bg-fill-primary';
    }
  };
  
  const TextColor = (disabled: boolean, type: string) => {
    if (disabled && type === 'SOLID') {
      return 'text-disabled';
    } else if (!disabled && type === 'SOLID') {
      return 'text-on-action-primary';
    } else if (!disabled && type !== 'SOLID') {
      return 'text-action-primary';
    } else {
      return 'text-disabled';
    }
  };
  const bg = ButtonBg(disabled, type);
  const textColor = TextColor(disabled, type);

  if(type === 'TEXT'){
    return(
      <ThemedPressable
      eventName={eventName}
      eventProperties={additionalProperties}
      size="SM"
      disabled={disabled}
      onPress={() => {
        handlePress();
      }
      }>
        <ThemedText variant='b2b' color={disabled ? "text-disabled" : "text-action-primary"} style={{fontSize:textSize[size]}} >
          {label}
        </ThemedText>
      </ThemedPressable>
    )
  }

  return (
    <ThemedPressable
      eventName={eventName}
      eventProperties={additionalProperties}
      flexDirection='row'
      justifyContent='center'
      alignItems='center'
      width={'100%'}
      height={buttonSize[size]}
      borderWidth={type==='OUTLINED' || disabled ?1:0}
      borderRadius='2xl'
      borderColor={disabled ? 'border-disabled' :'border-action'}
      disabled={disabled}
      onPress={() => {
              handlePress()
      }}
      backgroundColor={bg}
      style={[
        showShadow && ls.buttonShadow,
        overRideStyle
      ]}>
      {!buttonLoader && showLeftAccessory && leftAccessory()}
      <ThemedText variant='b1b' mx="md" color={textColor} fontSize={textSize[size]}>
        {label}
      </ThemedText>
      {!buttonLoader && showRightAccessory && rightAccessory()}
      {buttonLoader && <ActivityIndicator color={'white'} size={'small'} />}
    </ThemedPressable>
  );
};
export default Button;
